import { InvestmentBalancesProps } from 'modules/clients/types/transaction-summary';
import styles from '../transaction-summary.module.scss';
import TransactionSummaryHeadingRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryHeadingRow';
import TransactionSummaryRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryRow';

const InvestmentBalances = ({
  openingBalance,
  openingBalanceDate,
  closingBalance,
  closingBalanceDate
}: InvestmentBalancesProps) => {
  return (
    <div className={styles.container}>
      <TransactionSummaryHeadingRow
        testid='transactionSummaryInvestmentBalance'
        data-testid='transactionSummaryInvestmentBalanceHeading'
        heading='Investment balances'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryOpeningBalanceRow'
        heading={`Opening balance at ${openingBalanceDate}`}
        amount={openingBalance}
        testid='transactionSummaryOpeningBalance'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryOpeningBalanceRow'
        heading={`Closing balance at ${closingBalanceDate}`}
        amount={closingBalance}
        testid='transactionSummaryClosingBalance'
      />
    </div>
  );
};

export default InvestmentBalances;
